import { useRef } from 'react';
import { Box, Container, Typography, Grid, alpha } from '@mui/material';
import { motion, useInView } from 'framer-motion';

const P = { main: '#9995ffff', light: '#34d399', dark: '#059669' };

const WIDGETS = [
  { img: '/assets/icon/bell.webp', title: 'Duyuru Widget\'ları', desc: 'Güncel duyuruları sabit veya liste halinde web sitenizde yayınlayın.', color: '#f97316' },
  { img: '/assets/icon/project.webp', title: 'Proje Widget\'ları', desc: 'Projelerinizi ilerleme durumlarıyla birlikte ziyaretçilere gösterin.',color: '#0891b2' },
  { img: '/assets/icon/event.webp', title: 'Faaliyet Widget\'ları', desc: 'Yürütülen faaliyetleri kategori bazlı olarak sergileyin.', color: '#f43f5e' },
  { img: '/assets/icon/calendar.webp', title: 'Etkinlik Widget\'ları', desc: 'Yaklaşan ve geçmiş etkinlikleri web sitenizde listeleyin.' , color: '#8b5cf6'},
  { img: '/assets/icon/list.webp', title: 'Liste & Tablo Widget\'ları', desc: 'Projeleri, faaliyetleri veya içerikleri tablo ve liste formatında gösterin.', color: '#10b981' },
  { img: '/assets/icon/gallery.webp', title: 'Slider & Vitrin Widget\'ları', desc: 'Öne çıkan içerikleri slider veya vitrin alanlarında sunun.',color: '#eab308'},
  { img: '/assets/icon/add.webp', title: 'Galeri Widget\'ları', desc: 'Fotoğraf ve görselleri albüm veya galeri şeklinde yayınlayın.' , color: '#6366f1'},
  { img: '/assets/icon/association.webp', title: 'Sabit İçerik Widget\'ları', desc: 'Hakkımızda, iletişim, metin ve bilgilendirme alanlarını yönetin.', color: '#ec4899' },
];

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.07 },
  }),
};

export default function WidgetTypesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <Box
      ref={ref}
      sx={{
        py: { xs: 4, md: 10 },
        background: '#ffffff',
        borderTop: '1px solid #f1f5f9',
      }}
    >
      <Container maxWidth="lg">

        <motion.div variants={fadeUp} initial="hidden" animate={isInView ? 'visible' : 'hidden'}>
          <Box textAlign="center" mb={{ xs: 6, md: 9 }}>
            <Typography
              variant="h3" fontWeight={700} mb={2} color="#0f172a"
            >
              Widget Türleri ile Sayfanızı 
              <br/>
              Baştan Aşağı Oluşturun
            </Typography>
            <Typography sx={{
              color: '#64748b', fontSize: '1rem',
              maxWidth: 560, mx: 'auto', lineHeight: 1.75,
            }}>
              Bağıştan kurumsal sayfalara, projelerden banka bilgilerine kadar
              web sitenizin tüm alanlarını dinamik ve yönetilebilir hale getirin.
            </Typography>
          </Box>
        </motion.div>

        <Grid container spacing={2.5}>
          {WIDGETS.map((item, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <motion.div
                variants={fadeUp}
                custom={i + 1}
                initial="hidden"
                animate={isInView ? 'visible' : 'hidden'}
                style={{ height: '100%' }}
              >
                <Box
                  sx={{
                    p: 3, borderRadius: 2.5, height: '100%',
                    background: '#fafafa',
                    border: '1px solid #e5e7eb',
                    display: 'flex', flexDirection: 'column', gap: 1.75,
                    transition: 'all 0.25s ease',
                    cursor: 'default',
                    '&:hover': {
                      background: '#fff',
                      borderColor: item.color,
                      boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                      transform: 'translateY(-3px)',
                    },
                  }}
                >
                  <Box sx={{
                    width: 55, height: 55, borderRadius: 2,
                    padding:1,
                  bgcolor: alpha(item.color, 0.1),
                    border: `1px solid ${alpha(P.main, 0.15)}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <Box
                      component="img"
                      src={item.img}
                      alt={item.title}
                      sx={{ width: 40, height: 40, objectFit: 'contain' }}
                    />
                  </Box>

                  <Typography sx={{
                    fontWeight: 700, fontSize: '0.9rem',
                    color: '#0f172a', lineHeight: 1.3,
                  }}>
                    {item.title}
                  </Typography>

                  <Typography sx={{
                    fontSize: '0.82rem', color: '#64748b', lineHeight: 1.65,
                  }}>
                    {item.desc}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>

      </Container>
    </Box>
  );
}
